<a [ngClass]="{'line-button':true, 'green-link':green!=undefined, 'disabled':disabled}">
  <li class="line-button-before">–</li>
  <ng-content></ng-content>
  <li class="line-button-after">–</li>
</a>